import { render } from "./SocialPost.vue?vue&type=template&id=6aaacb96&scoped=true"
import script from "./SocialPost.vue?vue&type=script&lang=js"
export * from "./SocialPost.vue?vue&type=script&lang=js"

import "./SocialPost.vue?vue&type=style&index=0&id=6aaacb96&lang=scss"
import "./SocialPost.vue?vue&type=style&index=1&id=6aaacb96&lang=scss&scoped=true"
import "./SocialPost.vue?vue&type=style&index=2&id=6aaacb96&lang=scss"

import exportComponent from "C:\\Users\\alexg\\Desktop\\martech\\whappy-app-front-vue-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6aaacb96"]])

export default __exports__